import React, { useCallback, useContext, memo } from "react";

// context
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";

// components
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";

// utils
import { callApi } from "bodycodi/cmap/app/js/common";
import Drawer from "@material-ui/core/Drawer";

// assets
import icon_update from "bodycodi/cmap/app/img/icon_update.png";
import icon_delete_red from "bodycodi/cmap/app/img/icon_delete_red.png";

type ComunityconfirmPopWrap = {
  d: any;
};

type ComunityconfirmPop = {
  d: any;
  handleClose: Function;
};

function ComunityconfirmPopWrap({ d }: ComunityconfirmPopWrap) {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "COMUNITY_CONFIRM_POP",
      open: { comunityConfirmPop: false },
    });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.comunityConfirmPop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <PickerHeader title="" onClose={handleClose} />
      <ComunityconfirmPop d={d} handleClose={handleClose} />
    </Drawer>
  );
}

function ComunityconfirmPop({ d, handleClose }: ComunityconfirmPop) {
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const { dispatch } = useContext(DispatchContext);

  const openUpdPop = useCallback(() => {
    handleClose();
    dispatch({ type: "POP_UP_OPEN", id: "COMUNITY_UPD_POP", open: { comunityUpdPop: true } });
  }, []);

  const deletePost = useCallback(() => {
    callApi(`/community/${d.uploadId}/delete`, {}, "POST").then((res) => {
      homeDispatch({ type: "UPDATE_COMUNITY" });
      handleClose();
      dispatch({ type: "POP_UP_OPEN", id: "COMUNITY_DTL_POP", open: { comunityDtlPop: false } });
      dispatch({ type: "UPDATE", data: { toast1: true, toastText: "게시글을 삭제했습니다." } });
    });
  }, [d]);

  const deleteConfirmAlert = useCallback(() => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: "D",
        redYn: true,
        header: "게시글 삭제",
        body: "해당 게시글을\n삭제하시겠습니까?",
        cancelAlert: () => {},
        closeAlert: deletePost,
      },
    });
  }, [deletePost]);

  return (
    <>
      <div className="comment-confirm-pop">
        <div className="btn" onClick={openUpdPop}>
          <img src={icon_update} alt="" />
          수정
        </div>
        <div className="btn_red" onClick={deleteConfirmAlert}>
          <img src={icon_delete_red} alt="" />
          삭제
        </div>
      </div>
    </>
  );
}

export default memo(ComunityconfirmPopWrap);
